import { jarallax, jarallaxVideo } from "jarallax";

jarallaxVideo();

export default {
    init: function () {
        // Initialize jarallax for each instance and set its options
        document.querySelectorAll(".jarallax").forEach((node) => {
            let options = JSON.parse(node.dataset.jarallaxOptions || "");

            if (options.disableMobile) {
                options.disableMobile = /iPad|iPhone|iPod|Android/;
            }

            // Set the initial opacity to 0 to ensure it's hidden
            node.style.opacity = '0';

            jarallax(node, options);
        });

        // Wait for 2 seconds then fade in
        setTimeout(function() {
            let jarallaxDivs = document.querySelectorAll('.jarallax');
            jarallaxDivs.forEach(div => {
                div.style.transition = 'opacity 0.3s'; // You can adjust the duration if needed
                div.style.opacity = '1';
            });
        }, 1180);

        // Additional global jarallax initialization (if required)
        jarallax(document.querySelectorAll(".jarallax"), {
            onDestroy: function () {}
        });
    },
    cleanup: function () {
        jarallax(document.querySelectorAll(".jarallax"), "destroy");
    }
};
